export const recordingRulesEventDataSelector = (data) => {
  if (!data) return []
  const { groups: { collection } } = data
  return [...collection]
}

export const updateEventsObj = (eventTypes = [], selectedEvents = []) => eventTypes.map((eventType) => {
  const newItems = eventType.items.collection.map((ev) => ({ ...ev, selected: !!selectedEvents.includes(ev.id) })
  )
  const pagination = eventType.items.pagination ? (() => {
    const restPagination = { ...eventType.items.pagination }
    const totalCount = restPagination.total_count ?? restPagination.totalCount
    delete restPagination.total_count
    return {
      ...restPagination,
      totalCount,
    }
  })() : null
  return ({ ...eventType, items: newItems, pagination })
})

export const updateSelectedEvents = (collection, selectedEvents = []) => collection.map(
  (ev) => ({ ...ev, selected: !!selectedEvents.includes(ev.id) })
)

export const getNewSelectedEventTypes = (oldEventTypeSet, eventTypes) => {
  const newEventTypeSet = new Set([...oldEventTypeSet])
  for (const eventType of eventTypes) {
    for (const item of eventType.items) {
      if (item.selected) {
        newEventTypeSet.add(item.id)
      } else {
        newEventTypeSet.delete(item.id)
      }
    }
  }
  return newEventTypeSet
}
